import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserManagementAPI } from '../shared/constant/url.constant';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private readonly http: HttpClient, private readonly router: Router) {}

  // Utility to get headers with agency-id and user-id if available
  private getHeaders(includeUserId: boolean = true): HttpHeaders {
    const agencyId = sessionStorage.getItem('agencyId');
    const userId = sessionStorage.getItem('userId');
    const token = sessionStorage.getItem('applicationToken');
    let headers = new HttpHeaders();
    if(token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    if (agencyId) {
      headers = headers.set('agency-id', agencyId);
    }
    if (includeUserId && userId) {
      headers = headers.set('user-id', userId);
    }
    return headers;
  }

  addUser(user: any, agency: any) {
    const requestBody = {
      firstName: user.firstName,
      middleName: user.middleName,
      lastName: user.lastName,
      email: user.email,
      role: user?.role?.toUpperCase(),
      agency
    };
    return this.http.post(
      UserManagementAPI.AddUser,
      requestBody,
      { 
        headers: this.getHeaders(),
        responseType: 'text' }
    );
  }

  getUsers(page: number, limit: number, keyword: string = '') {
    const url = `${UserManagementAPI.GetUsers}?page=${page}&limit=${limit}&keyword=${encodeURIComponent(keyword)}`;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  getUserById(id: string) {
    return this.http.get(`${UserManagementAPI.GetUserById}/${id}`, { headers: this.getHeaders() });
  }

  updateUser(user: any, userId: string, agency: any) {
    const requestBody = {
      firstName: user.firstName,
      middleName: user.middleName,
      lastName: user.lastName,
      email: user.email,
      role: user?.role?.toUpperCase(),
      agency
    };
    return this.http.put(
      `${UserManagementAPI.UpdateUser}/${userId}`,
      requestBody,
      { headers: this.getHeaders(), responseType: 'text' }
    );
  }

  deleteUser(id: string) {
    return this.http.delete(
      `${UserManagementAPI.UpdateUser}/${id}`,
      { 
        headers: this.getHeaders(),
        responseType: 'text' }
    );
  }

  getAgencyId(agencyUrl: string): Observable<any> {
    return this.http.get(`${UserManagementAPI.GetAgencyId}${agencyUrl}`, { headers: this.getHeaders() });
  }

  findByEmailUser(email: string) {
    return this.http.get(
      UserManagementAPI.FindByEmailUser,
      {
        headers: this.getHeaders(),
        params: { email }
      }
    );
  }
  redirectToLogin(error: any, message: string) {
    console.log(error);
    if(error?.status == 401) {
      alert("Your session has expired. Please login again.");
    }
    else if(error?.status == 403) {
      alert("No user found with email: " + (message || sessionStorage.getItem('email')));
    }
    this.router.navigate(['/']);
    sessionStorage.removeItem('givenName');
    sessionStorage.removeItem('familyName');
    sessionStorage.removeItem('applicationToken');
  }
}